/**
 * Helper: Storage Namespaces
 * ------------------------------------------------------------------------------
 * - Global configuration for consistent namespaces between components when
 *   using sessionStorage and localStorage.
 *
 * @namespace storageNamespace
 */
/**
 * Export object for local/sessionStorage.
 */
export const storageNamespace = {
  attraqtSessionId: 'attraqtsessionid',
  bloomreachCheckout: 'persist:bloomreachCheckout',
  bloomreachCustomer: 'persist:bloomreachCustomer',
  cartUpdateSize: 'persist:updateCartSize',
  checkoutMarketingConsent: 'persist:checkoutMarketing',
  customerFormSubmit: 'persist:loginRegister',
  customerId: 'persist:customerId',
  customerTrackingConsent: 'persist:customerTrackingConsent',
  newsletterSubmit: 'persist:datitudeSubmit',
  recentlyViewedProducts: 'persist:recentlyViewed',
  wishlistProducts: 'swym-products',
  pinia: {
    cart: 'persist:cart',
    locale: 'persist:locale',
    product: 'persist:product',
    wishlist: 'persist:wishlist',
  },
  plp: {
    columnCount: 'persist:plpColumnCount',
    scrollRestore: 'persist:plpScrollPosition',
  },
}

/**
 * Export object for cookies.
 */
export const cookieNamespace = {
  geolocation: 'persist_geolocation',
  qaMode: 'persist_qaMode',
}
